var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('h1',[_vm._v(_vm._s(_vm.$vuetify.lang.t("$vuetify.user_settings")))]),_c('v-tabs',{staticStyle:{"border-bottom":"rgba(0, 0, 0, 0.1) solid thin"},attrs:{"value":_vm.tab,"icons-and-text":""},on:{"change":_vm.onAccountTabChange}},[_c('v-tab',{staticStyle:{"min-width":"160px"},attrs:{"value":0}},[_vm._v(" "+_vm._s(_vm.$vuetify.lang.t("$vuetify.profile"))+" "),_c('v-icon',[_vm._v("mdi-account-group-outline")])],1),_c('v-tab',{staticStyle:{"min-width":"160px"},attrs:{"value":1}},[_vm._v(" "+_vm._s(_vm.$vuetify.lang.t("$vuetify.account_connections_tab"))+" "),_c('v-icon',[_vm._v("mdi-link-variant")])],1),_c('v-tab',{staticStyle:{"min-width":"160px"},attrs:{"value":2}},[_vm._v(" "+_vm._s(_vm.$vuetify.lang.t("$vuetify.admin.statistics.title"))+" "),_c('v-icon',[_vm._v("mdi-chart-areaspline-variant")])],1),(_vm.canAccessProgression)?_c('v-tab',{staticStyle:{"min-width":"160px"},attrs:{"value":3}},[_vm._v(" "+_vm._s(_vm.$vuetify.lang.t("$vuetify.progression_title"))+" "),_c('v-icon',[_vm._v("mdi-medal-outline")])],1):_vm._e()],1),_c('v-tabs-items',{attrs:{"value":_vm.tab}},[_c('v-tab-item',{attrs:{"value":0}},[_c('UserSettings')],1),_c('v-tab-item',{attrs:{"value":1}},[_c('AccountConnections')],1),_c('v-tab-item',{attrs:{"value":2}},[_c('SpaceStatistics',{attrs:{"statsToDisplay":[
        'standard_subscription',
        'kiosk_subscription',
        'express_subscription',
        'active_proposition',
        'active_worker',
        'associated_worker',
        'worker_user',
        'order',
        'order_fully_honored',
        'order_partially_honored',
        'order_non_honored',
        'order_quantity',
        'sms_job_proposition',
        'accepted_job_proposition',
        'order_job_taken',
        'dpae_confirmation',
        'availability_request',
        'non_interpreted_answer',
        'availability_request_qualification',
        'availability_request_link_qualification',
        'message_sent',
        'message_received',
        'availability_history',
        'worker_in_contract',
        'applicant',
        'applicant_jobboard',
        'application',
        'application_jobboard']}})],1),(_vm.canAccessProgression)?_c('v-tab-item',{attrs:{"value":3}},[_c('Progression')],1):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }